import { RPCs } from "../../../services/rpc.js";
import { SelectMultiOptionWrapper } from "../../../components/Select/SelectMultiOptionWrapper.js";
import { SelectAsyncRPC } from "../../../components/Select/SelectAsyncRPC.js";
import { UserBadgeWide } from "../../Users/shared/UserBadgeWide.js";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/Scheduling/shared/SelectSchedulingUser.tsx
var Base = ({ schedulingUser }) => {
	if (!schedulingUser) return null;
	const { user } = schedulingUser;
	return /* @__PURE__ */ jsx(UserBadgeWide, {
		user: {
			avatarUrl: user.avatarUrl,
			displayName: user.displayName,
			idNumber: user.profile.idNumber,
			title: user.profile.title
		},
		size: "sm"
	});
};
var SelectSchedulingUserRenderComponents = {
	ListItem: ({ userOption }) => /* @__PURE__ */ jsx(Base, { schedulingUser: userOption }),
	SelectedMulti: (schedulingUser, onRemove) => /* @__PURE__ */ jsx(SelectMultiOptionWrapper, {
		onRemove,
		children: /* @__PURE__ */ jsx("div", {
			className: "px-sm max-w-full",
			children: /* @__PURE__ */ jsx(Base, { schedulingUser })
		})
	}),
	SelectedSingle: (schedulingUser) => /* @__PURE__ */ jsx(Base, { schedulingUser })
};
var responseOptionsExtractor = (data) => data?.schedulingUsers.map((schedulingUser) => schedulingUser);
var SelectSchedulingUser = ({ active = true, idFilter, limit = 25, multi, value, ...atalayaSelectProps }) => /* @__PURE__ */ jsx(SelectAsyncRPC, {
	RenderListItem: (list) => /* @__PURE__ */ jsx(SelectSchedulingUserRenderComponents.ListItem, { userOption: list }),
	RenderSelectedListItem: (list) => /* @__PURE__ */ jsx(SelectSchedulingUserRenderComponents.ListItem, { userOption: list }),
	RenderSelectedMulti: SelectSchedulingUserRenderComponents.SelectedMulti,
	RenderSelectedSingle: SelectSchedulingUserRenderComponents.SelectedSingle,
	args: {
		active,
		idFilter
	},
	idProp: "id",
	limit,
	multi,
	optionLabelExtractor: ({ displayName }) => displayName,
	optionValueExtractor: ({ id }) => id,
	request: RPCs.Scheduling.GetSchedulingUsers.v1,
	requestFilterProp: "idFilter",
	responseOptionsExtractor,
	value,
	...atalayaSelectProps
});
//#endregion
export { SelectSchedulingUser, SelectSchedulingUserRenderComponents };

//# sourceMappingURL=SelectSchedulingUser.js.map